// extracted by mini-css-extract-plugin
export var section = "S2BbF9uf";
export var main = "QaHT2jTj";
export var pattern = "_0mtz7xBz";
export var container = "SC6w40p+";
export var body = "OQhq3CpO";
export var portal = "Tn-jbBjg";
export var doughnutContainer = "SCaDtCK4";